import React, { useContext } from 'react';
import Header from './Header';
import { ThemeContext } from '../context/ThemeContext';
import styles from './Layout.module.css';

const Layout = ({ children }) => {
    const { theme } = useContext(ThemeContext);

    return (
        <div className={`${styles.layout} ${styles[theme]}`}>
            <Header />
            <main className={styles['main-content']}>
                {children}
            </main>
        </div>
    );
};

export default Layout;
